<script setup>
import calendar from '@Common/utils/calendar_helpers'
import LoadingWidget from '@Common/elements/LoadingWidget'
// thses need to be dealt with
import CalendarModal from '@/components/calendar/CalendarModal'
import { useMonthlyStore } from '@/stores/MonthlyStore'

import { ref, useTemplateRef, watch } from 'vue'
import moment from 'moment'

const purchaseSet = useMonthlyStore()
const calendarRef = useTemplateRef('calendarRef')
const dayBlock = useTemplateRef('dayBlock')
const dayBlockData = useTemplateRef('dayBlockData')
const modalRef = useTemplateRef('modalRef')
const dayBlockLabelRef = useTemplateRef('dayBlockLabel')
    
const { year, month, today } = defineProps({
  year: Number,
  month: Number,
  today: {
    type: Object,
    default: new Date() 
  }
})

const loading = ref(true)
const dayLabels = calendar.DAYS
const days = ref([])
const modalOptions = ref({})
const dayHeight = ref(0)
// TODO make these dynamic?
const dayLabelHeight = 19
const dataBlockHeight = 23
const ellipseHeight = 19

const jsMonth = ref(month - 1)

// TODO general the calendar data
const groupMonthlyData = () => {
  days.value = calendar.getDaysArray(year, jsMonth.value, today.getDate())

  purchaseSet.getSet.map(v => {
    const d = moment(v.date)
    v = {
      ...v,
      text: `${v.business.name} - ${v.category.name}`,
      fullText: v.desc,
      color: v.category.color,
      moment: d,
      cssClasses: '',
    }
    const index = days.value.findIndex(day => day.date === d.date() && day.month === d.month())
    if (!days.value[index].total) days.value[index].total = 0
    if (days.value[index].data) {
      days.value[index].data.push(v)
      days.value[index].total += v.amount
    } else {
      days.value[index] = {
        data: [v],
        total: v.amount,
      }
    }
  })
}

const onClickDataBlob = (blob) => {
  modalOptions.value = {
    header: blob.moment.format('MM/DD/YYYY'),
    data: blob,
  }
  modalRef.value.show()
}

const onClickOverflowEllipse = (day) => {
  days.value[day].showModal = true
}

const onClickCloseOverflow = (day) => {
  days.value[day].showModal = false
}

const fetchMonthlyData = () => {
  purchaseSet.fetch(year, month).then((r) => {
    loading.value = false
    groupMonthlyData()
    return r
  })
}

const formatTotal = (amt) => {
  return amt.toFixed(2)
}

const truncateBlockData = () => {
  const maxH = dayHeight.value - dayLabelHeight - ellipseHeight
  days.value.forEach(day => {   
    let h = dayLabelHeight
    day.hasOverflow = false
    day.data.forEach(d => {
      h += dataBlockHeight
      if (h >= maxH) {
        d.cssClasses += ' overflow'
        day.hasOverflow = true
      }
    })

    if (day.hasOverflow) {
      day.cssClasses += ' has-overflow'
    }
  })
}

fetchMonthlyData()

watch(dayBlock, (db) => {
  let h
  db.forEach((d, i) => {
    if (i === 0 || d.offsetHeight > h) h = d.offsetHeight
  })
  dayHeight.value = h
  truncateBlockData()
})

</script>

<template>
  <div class="calendar-cont">
    <div class="loading-wrapper" v-if="loading">
      <LoadingWidget type="bar"></LoadingWidget>
    </div>

    <div v-else class="calendar-wrapper">
      <div class="calendar-header">
        <div v-for="(day, i) in dayLabels"
          :key="i"
          class="day-header">
          {{day}}
        </div>
      </div>

      <div class="calendar-body" ref="calendarRef">
        <div class="day-block"
          v-for="(day, i) in days"
          :key="i"
          :class="day.cssClasses"
          ref="dayBlock">
          <div class="day-date-label flex justify-between" ref="dayBlockLabel">
            <span class="day">{{day.date}}</span>
            <span class="day-name">{{day.name}}</span>
            <span v-if="day.total" class="day-total child-right">${{formatTotal(day.total)}}</span>
            <span v-else class="day-total child-right">$0</span>
          </div>

          <div class="day-block-data" ref="dayBlockData" >
            <div 
              v-for="(blob, j) in day.data"
              :id="blob.id"
              :key="j"
              :class="blob.cssClasses"
              :style="{backgroundColor: blob.color}"
              @click="onClickDataBlob(blob, $event)"
              class="data-blob flex">
              <span class="blob-text">{{blob.text}}</span>
              <span class="child-right">${{formatTotal(blob.amount)}}</span>
            </div>

            <div v-if="day.hasOverflow" class="overflow-wrapper">
              <span class="overflow-ellipse"
                @click="onClickOverflowEllipse(i)">
                &bull;&bull;&bull;
              </span>

              <div class="overflow-modal" v-show="day.showModal">
                <div class="flex align-center">
                  <span class="day">{{day.date}} - ${{formatTotal(day.total)}}</span>
                  <span class="close child-right">
                    <i @click="onClickCloseOverflow(i)" class='material-symbols-outlined'>close</i>
                  </span>
                </div>
                <div 
                  v-for="(blob, j) in day.data"
                  :id="blob.id"
                  :key="j"
                  :style="{backgroundColor: blob.color}"
                  @click="onClickDataBlob(blob, $event)"
                  class="data-blob flex">
                  <span class="blob-text">{{blob.text}}</span>
                  <span class="child-right">${{blob.amount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <CalendarModal :modalOptions="modalOptions" ref="modalRef"/>
  </div>
</template>

<style lang="scss" scoped>
@import "@Common/styles/calendar";
</style>
